import React, { useContext } from "react";

import { useHistory } from "react-router-dom";

import "./catalog-filters.css";

import { FilterContext } from "../../../context/filterContext";
import CatalogSubFilters from "../catalog-sub-filters/catalog-sub-filters.component";

import { ReactComponent as RemoveIcon } from "../../../assets/cross.svg";
import CatalogFiltersTags from "../catalog-filters-tags/catalog-filters-tags.component";
import { useTranslation } from "react-i18next";

const CatalogFilters = ({ filters, isResponsive, toggleDrawer }) => {
  const { t } = useTranslation();
  const { searchState, setSearchState } = useContext(FilterContext);

  const { facetValueIds } = searchState;

  const updateFacetsValues = (fv) => {
    const { __typename } = fv;

    if (__typename === "FacetValue") {
      const facetValueId = fv;

      setSearchState({
        ...searchState,
        facetValueIds: [...facetValueIds, facetValueId],
      });
    } else if (__typename === "Collection") {
      setSearchState({
        ...searchState,
        facetValueIds: [],
        collectionId: fv,
        facetFaluesPerCollectionInit: true,
      });
    }
  };

  const removeFacetsValues = (fv) => {
    const { __typename } = fv;

    if (__typename === "FacetValue") {
      const facetValueId = fv.id;
      setSearchState({
        ...searchState,
        facetValueIds: facetValueIds.filter((fv) => {
          return fv.id !== facetValueId;
        }),
      });
    } else if (__typename === "Collection") {
      setSearchState({
        ...searchState,
        facetValueIds: [],
        collectionId: null,
      });
    }
  };

  return (
    <div className="catalog-filters">
      {isResponsive ? (
        <div>
          <div className="h5-medium catalog-filters__title">
            <span>{t("header.categories")}</span>
            <RemoveIcon onClick={toggleDrawer("bottom", false)} />
          </div>
          <CatalogFiltersTags />
        </div>
      ) : (
        <div className="h4-medium catalog-filters__title">
          {t("header.categories")}
        </div>
      )}

      {/* <CatalogCollectionsFilters
        updateFacetsValues={updateFacetsValues}
        removeFacetsValues={removeFacetsValues}
        collectionId={collectionId}
      /> */}

      <CatalogSubFilters
        updateFacetsValues={updateFacetsValues}
        removeFacetsValues={removeFacetsValues}
        filters={filters}
      />
    </div>
  );
};

export default CatalogFilters;
